import { render, staticRenderFns } from "./view-product-modal.vue?vue&type=template&id=3f3cf30c&"
import script from "./view-product-modal.vue?vue&type=script&lang=js&"
export * from "./view-product-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports